import request from '@/utils/request'

// businessKYCEntrance
export const businessKYCEntrance = (data) => {
  return request({
    url: '/api/producer/kyb',
    method: 'post',
    data: data,
    vconfig: {
      ContentType: 'application/json'
    }
  })
}
// personalKYCEntrance
export const personalKYCEntrance = (data) => {
  return request({
    url: '/api/producer/kyc',
    method: 'post',
    data: data,
    vconfig: {
      ContentType: 'application/json'
    }
  })
}

// producer set well info
export const addWell = (data) => {
  return request({
    url: '/api/producer/addWell',
    method: 'post',
    data: data,
    vconfig: {
      ContentType: 'application/json'
    }
  })
}
// producer update my well info
export const updateWell = (data) => {
  return request({
    url: '/api/producer/updateWell',
    method: 'post',
    data: data,
    vconfig: {
      ContentType: 'application/json'
    }
  })
}
export const updateWellParams = (data) => {
  return request({
    url: '/api/producer/updateWellParams',
    method: 'post',
    data: data,
    vconfig: {
      ContentType: 'application/json'
    }
  })
}
export const checkWell = (data) => {
  return request({
    url: '/api/producer/checkWell',
    method: 'post',
    data: data
  })
}
